export function parseHAR(data) {
  const entries = data.log?.entries || [];
  return entries.map((e, i) => {
    const url = e.request?.url || '';
    let parsedUrl = null;
    try { parsedUrl = new URL(url); } catch (_) {}

    const domain = parsedUrl?.hostname || url.split('/')[2] || '';
    const path = parsedUrl
      ? parsedUrl.pathname + parsedUrl.search + parsedUrl.hash
      : url;
    const method = e.request?.method || 'GET';
    const status = e.response?.status || 0;
    const mimeType = e.response?.content?.mimeType || '';
    const size = e.response?.content?.size ?? e.response?._transferSize ?? 0;
    const time = Math.round(e.time || 0);
    const startedAt = e.startedDateTime || '';
    const reqHeaders = e.request?.headers || [];
    const resHeaders = e.response?.headers || [];
    const queryParams =
      parsedUrl && parsedUrl.search
        ? [...parsedUrl.searchParams.entries()].map(([k, v]) => ({ name: k, value: v }))
        : e.request?.queryString || [];
    const postData = e.request?.postData || null;
    const resBody = e.response?.content?.text || null;
    const resEncoding = e.response?.content?.encoding || null;
    const httpVersion = e.request?.httpVersion || '';
    const timings = e.timings || {};

    return {
      id: i,
      url,
      domain,
      path,
      method,
      status,
      mimeType,
      size,
      time,
      startedAt,
      reqHeaders,
      resHeaders,
      queryParams,
      postData,
      resBody,
      resEncoding,
      httpVersion,
      timings,
      typeCategory: getTypeCategory(mimeType, e._resourceType || ''),
    };
  });
}

export function getTypeCategory(mimeType, resourceType) {
  const m = (mimeType || '').toLowerCase();
  const r = (resourceType || '').toLowerCase();
  if (r === 'xhr' || r === 'fetch' || m.includes('json') || m.includes('xml')) return 'xhr';
  if (m.includes('javascript') || m.includes('ecmascript') || r === 'script') return 'js';
  if (m.includes('css') || r === 'stylesheet') return 'css';
  if (m.includes('image') || r === 'image') return 'img';
  if (m.includes('video') || m.includes('audio') || r === 'media') return 'media';
  if (m.includes('font') || r === 'font') return 'font';
  if (m.includes('html') || r === 'document') return 'doc';
  return 'other';
}

export function fmtSize(bytes) {
  if (!bytes || bytes < 0) return '—';
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / 1048576).toFixed(2) + ' MB';
}

export function fmtTime(ms) {
  if (!ms) return '—';
  if (ms < 1000) return ms + ' ms';
  return (ms / 1000).toFixed(2) + ' s';
}

export function timeClass(ms) {
  if (ms < 500) return 'fast';
  if (ms < 2000) return 'med';
  return 'slow';
}

export function statusColor(code) {
  if (code >= 500) return 'red';
  if (code >= 400) return 'red';
  if (code >= 300) return 'yellow';
  if (code >= 200) return 'green';
  return 'blue';
}

export function isInScope(domain, target) {
  if (!target) return false;
  const cleanTarget = target.replace(/^https?:\/\//, '').split('/')[0].toLowerCase();
  const domLower = (domain || '').toLowerCase();
  return domLower === cleanTarget || domLower.endsWith('.' + cleanTarget);
}

export function copyToClipboard(text) {
  if (navigator.clipboard) {
    return navigator.clipboard.writeText(text);
  }
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  document.execCommand('copy');
  ta.remove();
  return Promise.resolve();
}
